
const colorJson = require('customtheme.json').color;

export const color = {
  black: '#000',
  white: '#fff',
  primary: '#000',
  ...colorJson,
};
